<input type="text" 
      #inputRef
      class="dutch-currency-field"
      (focus)="toNumber($event)"
      (keypress)="numberOnlyValidation($event)"
      (keyup)="updateModel($event)"
      (blur)="format($event)" />